module.exports = __webpack_public_path__ + "static/media/TradeGothicBold.9de06b4b.otf";